import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("De nieuwe wachtwoorden komen niet overeen");
      return;
    }
    setLoading(true);
    try {
      await api.auth.changePassword({ current_password: current, new_password: next });
      toast.success("Je wachtwoord is gewijzigd");
      reset();
      onOpenChange(false);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Wijzigen mislukt");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
      <DialogContent className="max-w-md bg-[var(--paper)]" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-serif text-xl text-[var(--ink)]">
            <KeyRound className="h-5 w-5 text-[var(--brand)]" /> Wachtwoord wijzigen
          </DialogTitle>
          <DialogDescription className="text-sm text-[var(--ink-3)]">Kies een nieuw wachtwoord voor je account.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <span className="mb-1 block font-mono text-[11px] uppercase tracking-wider text-[var(--ink-3)]">Huidig wachtwoord</span>
            <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="change-current-input"
              className="h-11 w-full rounded-lg border border-[var(--border-subtle)] bg-[var(--surface)] px-3 text-sm text-[var(--ink)] outline-none focus:ring-2 focus:ring-[var(--brand)]" />
          </label>
          <label className="block">
            <span className="mb-1 block font-mono text-[11px] uppercase tracking-wider text-[var(--ink-3)]">Nieuw wachtwoord (min. 6 tekens)</span>
            <input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} data-testid="change-new-input"
              className="h-11 w-full rounded-lg border border-[var(--border-subtle)] bg-[var(--surface)] px-3 text-sm text-[var(--ink)] outline-none focus:ring-2 focus:ring-[var(--brand)]" />
          </label>
          <label className="block">
            <span className="mb-1 block font-mono text-[11px] uppercase tracking-wider text-[var(--ink-3)]">Herhaal nieuw wachtwoord</span>
            <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="change-confirm-input"
              className="h-11 w-full rounded-lg border border-[var(--border-subtle)] bg-[var(--surface)] px-3 text-sm text-[var(--ink)] outline-none focus:ring-2 focus:ring-[var(--brand)]" />
          </label>
          <button type="submit" disabled={loading} data-testid="change-submit-button"
            className="flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-[var(--brand)] text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}
            Opslaan
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
